import styled from 'styled-components'
import { Text } from 'rebass'

export const Card = styled.div`
  background: ${({ theme }) => theme.bg1};
  border-radius: 20px;
  color: ${({theme}) => theme.bsText3};
  width: 362px;
`

export const BodyHead = styled.div<{bottom?: string}>`
  color: ${({theme}) => theme.bsText3};
  text-align: center;
  margin-bottom: ${({bottom}) => bottom ? bottom : '50px'};
`
export const BodyTitle = styled(Text)`
  font-family: Baloo Da;
  color: ${({theme}) => theme.text1};
`
